// extracted by mini-css-extract-plugin
export var createdDate = "_mx-1";
export var divider = "_mx-2";
export var headerDivider = "_mx-3";
export var messagesCard = "_mx-0";
export var messagesContainer = "_mx-7";
export var messagesContainerWrapper = "_mx-4";
export var pointerCapturingButtonBoxes = "_mx-a";
export var showLeftPanelButton = "_mx-9";
export var showMoreButton = "_mx-c";
export var showMoreButtonContainer = "_mx-b";
export var summaryTitle = "_mx-6";
export var systemMessageCardWrapper = "_mx-d";
export var topButtons = "_mx-8";
export var withPadding = "_mx-5";